import { LinkedIn } from '@mui/icons-material';
import type { CollectiveGroupResponse } from '@on3/api';
import { Instagram } from 'components/Svg/Instagram';
import { TikTok } from 'components/Svg/TikTok';
import { Twitter } from 'components/Svg/Twitter';
import { Text } from 'components/UI/Typography/Text';

import styles from './FoundersModule.module.scss';

interface props {
  data: CollectiveGroupResponse;
}

export const FoundersModule = ({ data }: props) => {
  const { founders } = data;

  return (
    <div className={styles.foundersContainer}>
      <Text className={styles.subTitle} variant="subtitle1">
        Founders
      </Text>
      <ul className={styles.foundersList}>
        {founders?.map((founder) => (
          <li className={styles.founderItem} key={founder.key}>
            <div className={styles.lineOne}>
              <Text className={styles.founderName}>{founder.name}</Text>
              <Text className={styles.founderTitle}>{founder.title}</Text>
            </div>
            <div className={styles.lineTwo}>
              {founder.instagramHandle && (
                <a
                  className={styles.socialLink}
                  href={`https://www.instagram.com/${founder.instagramHandle}/`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <Instagram className={styles.founderSocialIcon} />
                </a>
              )}
              {founder.linkedInHandle && (
                <a
                  className={styles.socialLink}
                  href={`${founder.linkedInHandle}`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <LinkedIn className={styles.founderSocialIcon} />
                </a>
              )}
              {founder.tikTokHandle && (
                <a
                  className={styles.socialLink}
                  href={`https://tiktok.com/@${founder.tikTokHandle}`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <TikTok className={styles.founderSocialIcon} />
                </a>
              )}
              {founder.twitterHandle && (
                <a
                  className={styles.socialLink}
                  href={`https://twitter.com/${founder.twitterHandle}`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <Twitter className={styles.founderSocialIcon} />
                </a>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
